/* 訊息目錄。英文目錄以 Record<MessageKey, string> 宣告 ——
   少翻一條、多打一個字，TypeScript 當場就擋下來，不必等執行期才發現。 */

export const zhHant = {
  "app.name": "人生智囊",
  "app.locale.zh": "繁體中文",
  "app.locale.en": "English",

  "topbar.count.one": "{n} 條知識",
  "topbar.count.other": "{n} 條知識",
  "topbar.loading": "載入中…",
  "topbar.search": "搜尋知識",
  "topbar.adult": "成人區鎖定狀態",
  "topbar.trash": "垃圾桶",
  "topbar.settings": "設定",

  "nav.topic": "主題",
  "nav.topic.sub": "標本櫃",
  "nav.create": "建立",
  "nav.create.sub": "工作檯",
  "nav.tray": "靈感",
  "nav.tray.sub": "托盤",

  "banner.due": "份標本已過曆元",
  "banner.review": "重新測定 →",

  "error.storage": "儲存層出錯：{message}　你的資料沒有被寫入。",
  "loading.cabinet": "正在開啟標本櫃…",

  "empty.title": "空的抽屜",
  "empty.body": "這裡還沒有標本。先從一句話開始壓製 —— 匯入檔案在 M3 開放。",
  "empty.action": "到工作檯",

  "cabinet.label": "標本櫃：主類別",
  "cabinet.count.one": "{n} 份",
  "cabinet.count.other": "{n} 份",

  "cat.title": "類別管理",
  "cat.hint": "主類別是你的大抽屜，副類別是抽屜裡的隔板。改名、刪除、新增都會同步到其他裝置。",
  "cat.manage": "＋ 類別",
  "cat.manage.sub": "管理抽屜",
  "cat.all": "整個抽屜",
  "cat.new.main": "＋ 新增主類別",
  "cat.new.sub": "＋ 新增副類別",
  "cat.edit": "編輯",
  "cat.delete": "刪除",
  "cat.delete.confirm": "確定刪除？",
  "cat.delete.hint": "刪掉抽屜不會刪掉裡面的知識：它們會退回「未分類」，等你重新歸位。",
  "cat.name": "抽屜名稱",
  "cat.definition": "你自己的定義",
  "cat.definition.placeholder": "這個抽屜對你來說裝什麼？（主類別建議填）",
  "cat.reviewDefaultDays": "預設複習天數",
  "cat.linkCap": "每節點連結上限",
  "cat.linkCap.value": "{n} 條",
  "cat.system": "系統保留",
  "cat.saved": "已更新「{name}」",
  "cat.created": "已新增「{name}」",
  "cat.deleted": "已刪除「{name}」",
  "cat.deleted.moved": "已刪除抽屜，{n} 則知識退回未分類",
  "cat.uncategorized": "「{name}」由系統保留，不能刪除也不能改名 —— 沒有歸位的知識要有地方待著。",

  "sheet.invalid.from": "（從缺）",
  "sheet.invalid.badge": "◦ 台紙無效",
  "sheet.invalid.warning": "⚠ 沒有標籤的標本在科學上沒有價值：不進關係網、不計入搜尋，也不能存入。（標籤至少 {min} 字）",
  "sheet.note.label": "我為什麼要存它",
  "sheet.note.empty": "（未填寫）",
  "sheet.source": "來源",
  "sheet.due": "到期",
  "sheet.category": "類別",
  "sheet.meta": "{sentences} / 2 句 · {chars} / {max} 字 · 第 {rev} 版",
  "sheet.edit": "編輯",
  "sheet.body.show": "展開正文",
  "sheet.body.hide": "收起正文",
  "sheet.history": "版本歷史",
  "sheet.link.on": "拉一條棉線",
  "sheet.link.soon": "拉棉線（M3）",
  "sheet.link.title": "這一版還沒有連結功能，M3 會做",
  "sheet.trash": "移到垃圾桶",
  "sheet.body.empty": "（還沒有正文）",
  "graph.title": "知識圖譜",
  "graph.hint": "棉線是連結、吊牌是關係類型。縮小時標籤會自動消失 —— 字在手機上最貴。",
  "graph.empty": "還沒有棉線。先到台紙上拉一條，這裡就會長出東西。",
  "graph.nodes": "{n} 個節點 / {m} 條棉線",
  "graph.aggregated": "知識超過一次能畫的數量，已收斂成類別聚合球（共 {hidden} 條）",
  "graph.selected": "已選 {n} 個",
  "graph.export": "匯出 PNG",
  "graph.clear": "清除選取",
  "graph.zoomIn": "放大",
  "graph.zoomOut": "縮小",
  "graph.reset": "重設視角",
  "graph.exported": "已匯出圖譜 PNG（{n} 個節點）",
  "graph.pick": "點節點選取，拖曳可移動視角，滾輪縮放",

  "link.new": "拉一條棉線",
  "link.target": "連到哪一條知識",
  "link.type": "關係類型",
  "link.note": "吊牌上的一句話",
  "link.create": "拉上",
  "link.delete": "剪掉",
  "link.cap": "已達每節點 {cap} 條的軟上限（本端 {from}、對端 {to}）—— 要填一句理由才能再連。",
  "link.self": "不能連到自己。",
  "link.duplicate": "這兩條之間已經有棉線了。",
  "link.created": "已拉上棉線",

  "sheet.strings.head": "棉線 {n} 條 / 上限 {cap}",
  "sheet.strings.empty": "還沒有連到別的知識。先拉一條棉線。",
  "sheet.strings.restricted": "受限的知識（解鎖成人區後才會顯示標題與內容）",

  "field.summary": "摘要（硬上限兩句）",
  "field.summary.aria": "摘要",
  "field.note": "採集標籤（必填）",
  "field.note.aria": "我為什麼要存它",
  "field.note.placeholder": "我為什麼要存它？用自己的話寫一句。",
  "field.source": "來源（檔名、書名或網址）",
  "field.category": "主類別",
  "field.interval": "複習間隔",
  "field.days.one": "{n} 天",
  "field.days.other": "{n} 天",
  "field.nsfw": "成人知識（獨立金鑰、未解鎖時完全隱形）",
  "field.body": "正文（可留白，之後再補）",
  "field.body.aria": "正文",
  "field.subcategories": "副類別（可多個）",
  "field.subcategories.none": "這個抽屜還沒有隔板，先用「＋ 類別」建一個。",

  "edit.title": "編輯：{title}",
  "edit.save": "儲存變更",
  "edit.cancel": "取消",

  "workbench.title": "壓製成知識",
  "workbench.subtitle": "兩句摘要 ＋ 一句動機",
  "workbench.hint": "匯入檔案與拖曳導入在 M3 開放；這一版先做手動輸入的完整流程。沒有採集標籤的標本不會算數 —— 但你可以先存成草稿，它不進主視圖、也不列入複習。",
  "workbench.save": "存入標本櫃",
  "workbench.draft": "先存成草稿",
  "workbench.ok": "標籤已填，可以存入。",

  "import.drop.work": "放到工作檯",
  "import.drop.workHint": "立刻解析成知識草稿 —— 兩句摘要 ＋ 來源，標籤留給你補。",
  "import.drop.tray": "放到托盤",
  "import.drop.trayHint": "先擱著（托盤的素材處理排在 M3 後段）。",
  "import.pick": "選檔案",
  "import.parsing": "解析中…",
  "import.imported": "已從 {file} 提煉 {n} 條草稿",
  "import.suggested": "建議類別：{name}",
  "import.duplicate": "這份已導入過：{file}",
  "import.empty": "{file}：抽不到足夠的內容（掃描件需要 OCR，那在桌面端）",
  "import.failed": "{file} 匯入失敗：{message}",
  "import.unsupported": "{file} 還不支援這種格式",
  "import.drafts.title": "待補採集標籤",
  "import.drafts.hint": "匯入產生的都是草稿：補上「我為什麼要存它」才會算數。補完之前不列入複習、不進搜尋、不進圖譜。",
  "import.drafts.none": "沒有待補的草稿。",
  "import.drafts.count": "{n} 條待補",
  "import.drafts.complete": "登錄",
  "import.drafts.discard": "丟棄",
  "import.drafts.done": "已登錄：{title}",
  "import.drafts.from": "出自 {source}",

  "tray.packs": "包",
  "tray.hidden": "另外 {n} 包已鎖定（需要解鎖成人區才看得到）",
  "tray.peel": "掀開",
  "tray.recover": "蓋回去",
  "tray.mark": "標記敏感",
  "tray.press": "壓製成知識",
  "tray.pressed": "已放上工作檯：寫下摘要與採集標籤",
  "tray.deleted": "已從托盤移除",
  "tray.peeled": "已掀開並記錄",
  "tray.marked": "已標記為敏感。成人區目前鎖定，所以它先隱藏起來了 —— 解鎖後才看得到它。",
  "tray.unmarked": "已取消敏感標記。",

  "tray.hint": "未編目的素材蓋著硫酸紙：掀開之前，標題與縮圖都看不到。掀開的動作會被記錄。匯入與拖曳導入在 M3 開放。",
  "tray.pick": "選檔案放進托盤",
  "tray.pick.soon": "M3 開放",
  "tray.empty": "托盤是空的。",
  "tray.glassine": "硫酸紙覆蓋中",
  "tray.sensitive": "敏感・未編目",
  "tray.unpeeled": "未掀開",
  "tray.goCreate": "前往建立",

  "history.title": "版本歷史：{title}",
  "history.hint": "每條知識保留最近 20 版或 30 天內的全部版本。回復是往前寫一筆新版本，歷史不會被改寫。",
  "history.version": "第 {n} 版",
  "history.current": "目前版本",
  "history.restore": "回復",

  "review.title": "重新測定",
  "review.none": "目前沒有到期的知識。",
  "review.hint": "一次一題。逾期的知識不會被鎖住 —— 只是提醒你回來看它還準不準。",
  "review.progress": "{index} / {total}",
  "review.due": "到期：{date}（已過 {days}）",
  "review.keep": "還準確・延長 {interval}",
  "review.edit": "要修改",
  "review.trash": "該淘汰",

  "search.title": "搜尋",
  "search.placeholder": "搜尋標題、摘要、正文、筆記、來源",
  "search.aria": "搜尋",
  "search.results.one": "{n} 筆結果",
  "search.results.other": "{n} 筆結果",
  "search.prompt": "輸入關鍵字",
  "search.locked": "成人區已鎖定：那些知識在查詢層就不會回傳，連筆數也不會顯示",
  "search.none": "沒有符合的知識。",
  "search.weights": "權重：標題 {title}／摘要 {summary}／筆記 {note}／來源 {source}／正文 {body}",
  "search.hitWeight": "命中權重 {score}",

  "trash.title": "垃圾桶",
  "trash.hint": "刪除的知識保留 30 天，過期後連同棉線與歷史一起永久移除。",
  "trash.empty": "垃圾桶是空的。",
  "trash.daysLeft": "{days} 後清除",
  "trash.restore": "還原",
  "trash.emptyAll": "清空垃圾桶（立即永久刪除）",

  "settings.title": "設定",
  "settings.language": "語言",
  "settings.language.auto": "跟隨系統",
  "settings.material": "台紙材質",
  "settings.material.night": "夜台紙",
  "settings.material.day": "日台紙",
  "settings.typeScale": "字級",
  "settings.scale.small": "小",
  "settings.scale.normal": "標準",
  "settings.scale.large": "大",
  "settings.adult": "成人區",
  "settings.adult.unlocked": "已解鎖（點擊上鎖）",
  "settings.adult.locked": "已鎖定（點擊解鎖）",
  "settings.adult.hint": "這一版只用開關示範；Face ID 解鎖需要真機驗證。",
  "export.title": "帶走你的資料",
  "export.hint": "匯出一包 zip：每條知識一個 Markdown 檔、一份完整 JSON、以及托盤裡還沒編目的素材。不依賴這個 App 也讀得懂。",
  "export.button": "匯出全部",
  "export.done": "已匯出 {n} 條知識（Markdown ＋ JSON）",

  "rail.strings": "棉線 {n} 條 / 上限 {cap}",
  "rail.due": "待複習 {n}",
  "rail.tray": "未編目托盤",
  "rail.tray.count.one": "{n} 包",
  "rail.tray.count.other": "{n} 包",
  "rail.status": "抽屜現況",
  "rail.category": "類別",
  "rail.specimens": "標本",
  "rail.drafts": "草稿",
  "rail.trash": "垃圾桶",
  "rail.linkCap": "棉線上限",
  "rail.specimens.value.one": "{n} 份",
  "rail.specimens.value.other": "{n} 份",
  "rail.linkCap.value": "12 條 / 張",

  "status.draft": "草稿",
  "status.active": "已登錄",
  "status.archived": "封存",
  "status.trashed": "垃圾桶",

  "toast.created": "已存入標本櫃",
  "toast.draft": "已存成草稿：補上採集標籤才會算數",
  "toast.saved": "已儲存（歷史多一版）",
  "toast.trashed": "已移到垃圾桶・30 天內可還原",
  "toast.restored": "已回復到第 {n} 版（歷史又往前一版）",
  "toast.kept": "已延長一個週期",
  "toast.dropped": "已淘汰・30 天內可還原",
  "toast.undeleted": "已還原：{title}",
  "toast.emptied.one": "已永久刪除 {n} 條（連同棉線與歷史）",
  "toast.emptied.other": "已永久刪除 {n} 條（連同棉線與歷史）",
  "toast.linkSoon": "連結功能在 M3 開放",
  "toast.noChange": "沒有變更",

  "sync.title": "同步",
  "sync.hint": "雲端只存密文：伺服器拿不到你的主密碼，也讀不到任何內容。",
  "sync.serverUrl.required": "請先填入同步伺服器網址 —— 加入既有的同步空間必須知道去哪裡找。",
  "sync.notSetup": "還沒有設定同步。設定之後，手機與電腦會透過伺服器交換加密後的變更。",
  "sync.serverUrl": "同步伺服器網址",
  "sync.serverUrl.placeholder": "例如 http://127.0.0.1:8795（自架）或 https://lifesage.xxx.workers.dev",
  "sync.setup": "建立主密碼",
  "sync.join": "加入既有的同步空間",
  "sync.join.keyId": "同步空間識別碼（在另一台裝置的同步設定裡）",
  "sync.passphrase": "主密碼（至少 12 個字元）",
  "sync.passphrase.confirm": "再輸入一次",
  "sync.passphrase.mismatch": "兩次輸入不一致。",
  "sync.passphrase.tooShort": "主密碼太短，至少 12 個字元。",
  "sync.passphrase.warn": "主密碼不會上傳，也不會被我們保存。忘記它只能用救援碼救回資料。",
  "sync.recovery.title": "這是你的救援碼 —— 請現在抄下來",
  "sync.recovery.hint": "忘記主密碼時，這是唯一能救回資料的東西。建議印出來或存進密碼管理器。它只會顯示這一次。",
  "sync.recovery.copy": "複製救援碼",
  "sync.recovery.copied": "已複製",
  "sync.recovery.confirm": "我已經把它記在安全的地方了",
  "sync.unlock": "解鎖同步",
  "sync.unlock.recovery": "改用救援碼解鎖",
  "sync.lock": "鎖定（清除這台裝置上的金鑰）",
  "sync.unlocked": "已解鎖",
  "sync.locked": "已鎖定",
  "sync.now": "立即同步",
  "sync.syncing": "同步中…",
  "sync.pending": "待推送 {n} 筆",
  "sync.lastAt": "上次同步 {time}",
  "sync.never": "尚未同步過",
  "sync.error": "同步失敗：{message}",
  "sync.offline": "離線：改動已存在本機，恢復連線後會自動補上",
  "sync.keyId": "同步空間",
  "sync.badPassphrase": "主密碼或救援碼不正確。",
  "sync.conflicts.title": "衝突待處理",
  "sync.conflicts.none": "沒有待處理的衝突。",
  "sync.conflicts.hint": "同一條知識在兩台裝置上被改過。這裡的副本保存了另一邊的版本 —— 兩份文字都還在，不會丢。",
  "sync.conflicts.take": "採用這個版本",
  "sync.conflicts.discard": "丟棄這個副本",
  "sync.conflicts.keepBoth": "兩條都保留",
  "sync.conflicts.toast.take": "已採用副本的內容，原知識多一版歷史",
  "sync.conflicts.toast.discard": "副本已移到垃圾桶（30 天內可還原）",
  "sync.conflicts.toast.keepBoth": "已保留成兩條獨立的知識",

  "selftest.title": "真實瀏覽器自我測試（IndexedDB）",

  "error.summary.empty": "摘要不能是空的。",
  "error.summary.tooLong": "摘要硬上限 {max} 字，目前 {actual} 字。",
  "error.note.tooShort": "採集標籤必填：用一句話寫下你為什麼要存它（至少 {min} 字，目前 {actual} 字）。",
  "error.category.missing": "每條知識都必須屬於一個主類別。",
  "warn.summary.tooManySentences": "摘要超過兩句（目前 {count} 句）—— 要不要拆成兩條知識？",
  "link.error.self": "不能連到自己。",
  "link.error.duplicate": "這兩條之間已經有棉線了。",
  "link.warn.capReached": "已達每節點 {cap} 條的軟上限（本端 {from}、對端 {to}）—— 要填一句理由才能再連。",

  "category.natural": "自然科學",
  "category.life": "生命科學",
  "category.medicine": "醫學與健康",
  "category.math": "數學",
  "category.engineering": "工程與技術",
  "category.cs": "資訊與程式",
  "category.social": "社會科學",
  "category.history": "歷史與人文",
  "category.language": "語言",
  "category.business": "商業與經濟",
  "category.law": "法律與制度",
  "category.art": "藝術與設計",
  "category.lifeSkills": "生活與技能",
  "category.uncategorized": "未分類",
  "category.uncategorized.definition": "還沒決定放哪裡。它們會出現在重新測定的佇列裡提醒你。",
} as const;

export type MessageKey = keyof typeof zhHant;

export const en: Record<MessageKey, string> = {
  "app.name": "LifeSage",
  "app.locale.zh": "繁體中文",
  "app.locale.en": "English",

  "topbar.count.one": "{n} knowledge item",
  "topbar.count.other": "{n} knowledge items",
  "topbar.loading": "Loading…",
  "topbar.search": "Search knowledge",
  "topbar.adult": "Adult area lock state",
  "topbar.trash": "Trash",
  "topbar.settings": "Settings",

  "nav.topic": "Topic",
  "nav.topic.sub": "Cabinet",
  "nav.create": "Create",
  "nav.create.sub": "Bench",
  "nav.tray": "Inbox",
  "nav.tray.sub": "Tray",

  "banner.due": "specimens past their epoch",
  "banner.review": "Re-measure →",

  "error.storage": "Storage error: {message}　nothing was written.",
  "loading.cabinet": "Opening the cabinet…",

  "empty.title": "An empty drawer",
  "empty.body": "No specimens here yet. Start by pressing one sentence into a sheet — file import arrives in M3.",
  "empty.action": "Go to the bench",

  "cabinet.label": "Cabinet: top-level categories",
  "cabinet.count.one": "{n} sheet",
  "cabinet.count.other": "{n} sheets",

  "cat.title": "Categories",
  "cat.hint": "A main category is a drawer; a subcategory is a divider inside it. Renames, additions, and deletions all sync to your other devices.",
  "cat.manage": "+ Category",
  "cat.manage.sub": "manage drawers",
  "cat.all": "Whole drawer",
  "cat.new.main": "+ New main category",
  "cat.new.sub": "+ New subcategory",
  "cat.edit": "Edit",
  "cat.delete": "Delete",
  "cat.delete.confirm": "Delete for real?",
  "cat.delete.hint": "Deleting a drawer never deletes the knowledge inside it: those entries move back to Uncategorised until you file them again.",
  "cat.name": "Drawer name",
  "cat.definition": "Your own definition",
  "cat.definition.placeholder": "What does this drawer hold, for you? (worth filling in for a main category)",
  "cat.reviewDefaultDays": "Default review interval",
  "cat.linkCap": "Links per node",
  "cat.linkCap.value": "{n} links",
  "cat.system": "system",
  "cat.saved": "Updated \u201C{name}\u201D",
  "cat.created": "Added \u201C{name}\u201D",
  "cat.deleted": "Deleted \u201C{name}\u201D",
  "cat.deleted.moved": "Drawer deleted; {n} entries moved back to Uncategorised",
  "cat.uncategorized": "\u201C{name}\u201D is reserved by the system and cannot be deleted or renamed \u2014 entries with no home need somewhere to wait.",

  "sheet.invalid.from": "(missing)",
  "sheet.invalid.badge": "◦ invalid sheet",
  "sheet.invalid.warning": "⚠ A specimen without a label has no scientific value: it stays out of the relation net, out of search, and cannot be filed. (Label needs at least {min} characters.)",
  "sheet.note.label": "Why I keep this",
  "sheet.note.empty": "(not written)",
  "sheet.source": "Source",
  "sheet.due": "Due",
  "sheet.category": "Category",
  "sheet.meta": "{sentences} / 2 sentences · {chars} / {max} characters · v{rev}",
  "sheet.edit": "Edit",
  "sheet.body.show": "Show body",
  "sheet.body.hide": "Hide body",
  "sheet.history": "Version history",
  "sheet.link.on": "Tie a string",
  "sheet.link.soon": "Tie a string (M3)",
  "sheet.link.title": "Linking is not in this build; it arrives in M3",
  "sheet.trash": "Move to trash",
  "sheet.body.empty": "(no body yet)",
  "graph.title": "Knowledge graph",
  "graph.hint": "Strings are links, tags carry the relation type. Labels vanish when you zoom out — text is the most expensive thing on a phone.",
  "graph.empty": "No strings yet. Tie one from a sheet and this view grows.",
  "graph.nodes": "{n} nodes / {m} strings",
  "graph.aggregated": "More knowledge than can be drawn at once — collapsed into category balls ({hidden} items)",
  "graph.selected": "{n} selected",
  "graph.export": "Export PNG",
  "graph.clear": "Clear selection",
  "graph.zoomIn": "Zoom in",
  "graph.zoomOut": "Zoom out",
  "graph.reset": "Reset view",
  "graph.exported": "Exported the graph as PNG ({n} nodes)",
  "graph.pick": "Click a node to select, drag to pan, scroll to zoom",

  "link.new": "Tie a string",
  "link.target": "Which item to connect",
  "link.type": "Relation type",
  "link.note": "One line for the tag",
  "link.create": "Tie it",
  "link.delete": "Cut",
  "link.cap": "This node reached its soft limit of {cap} strings (near end {from}, far end {to}) — write one line of reason to tie another.",
  "link.self": "A sheet cannot be tied to itself.",
  "link.duplicate": "These two are already tied.",
  "link.created": "String tied",

  "sheet.strings.head": "{n} strings / limit {cap}",
  "sheet.strings.empty": "Not connected to anything yet — tie a string first.",
  "sheet.strings.restricted": "Restricted knowledge (its title and content appear once the adult area is unlocked)",

  "field.summary": "Summary (hard limit: two sentences)",
  "field.summary.aria": "Summary",
  "field.note": "Collection label (required)",
  "field.note.aria": "Why I keep this",
  "field.note.placeholder": "Why do you want to keep this? Write it in your own words.",
  "field.source": "Source (file name, book, or URL)",
  "field.category": "Category",
  "field.interval": "Review interval",
  "field.days.one": "{n} day",
  "field.days.other": "{n} days",
  "field.nsfw": "Adult knowledge (separate key; completely invisible while locked)",
  "field.body": "Body (may stay empty for now)",
  "field.body.aria": "Body",
  "field.subcategories": "Subcategories (several allowed)",
  "field.subcategories.none": "This drawer has no dividers yet \u2014 add one under \u201C+ Category\u201D.",

  "edit.title": "Edit: {title}",
  "edit.save": "Save changes",
  "edit.cancel": "Cancel",

  "workbench.title": "Press into knowledge",
  "workbench.subtitle": "two sentences + one reason",
  "workbench.hint": "File import and drag-and-drop arrive in M3; this build covers the full manual path. A specimen without a label does not count — but you can save it as a draft: drafts stay out of the main view and out of review.",
  "workbench.save": "File into the cabinet",
  "workbench.draft": "Save as draft",
  "workbench.ok": "Label written — ready to file.",

  "import.drop.work": "Drop on the bench",
  "import.drop.workHint": "Parsed into draft knowledge right away — two-sentence summary plus source; the label is yours to write.",
  "import.drop.tray": "Drop in the tray",
  "import.drop.trayHint": "Park it for later (tray material handling lands late in M3).",
  "import.pick": "Choose files",
  "import.parsing": "Parsing…",
  "import.imported": "Extracted {n} drafts from {file}",
  "import.suggested": "Suggested category: {name}",
  "import.duplicate": "Already imported: {file}",
  "import.empty": "{file}: nothing substantial to extract (scanned documents need OCR, which lives on the desktop side)",
  "import.failed": "{file} failed to import: {message}",
  "import.unsupported": "{file} is not a supported format yet",
  "import.drafts.title": "Drafts waiting for a label",
  "import.drafts.hint": "Everything imported starts as a draft: it counts once you write why you keep it. Until then it stays out of review, search, and the graph.",
  "import.drafts.none": "No drafts waiting.",
  "import.drafts.count": "{n} waiting",
  "import.drafts.complete": "File it",
  "import.drafts.discard": "Discard",
  "import.drafts.done": "Filed: {title}",
  "import.drafts.from": "from {source}",

  "tray.packs": "packets",
  "tray.hidden": "{n} more are locked (unlock the adult area to see them)",
  "tray.peel": "Peel back",
  "tray.recover": "Cover again",
  "tray.mark": "Mark sensitive",
  "tray.press": "Press into knowledge",
  "tray.pressed": "On the bench: write the summary and the collection label",
  "tray.deleted": "Removed from the tray",
  "tray.peeled": "Peeled and recorded",
  "tray.marked": "Marked sensitive. The adult area is locked, so it is hidden for now — unlock to see it again.",
  "tray.unmarked": "Sensitive mark removed.",

  "tray.hint": "Uncatalogued material sits under glassine: until you peel it back, neither name nor thumbnail is visible. Peeling is recorded. Import arrives in M3.",
  "tray.pick": "Choose files for the tray",
  "tray.pick.soon": "arrives in M3",
  "tray.empty": "The tray is empty.",
  "tray.glassine": "under glassine",
  "tray.sensitive": "sensitive · uncatalogued",
  "tray.unpeeled": "Not peeled",
  "tray.goCreate": "Go to the bench",

  "history.title": "Version history: {title}",
  "history.hint": "Each item keeps its last 20 versions, or everything from the past 30 days, whichever is more. Restoring writes a new version forward; history is never rewritten.",
  "history.version": "v{n}",
  "history.current": "current version",
  "history.restore": "Restore",

  "review.title": "Re-measure",
  "review.none": "Nothing is due right now.",
  "review.hint": "One at a time. Overdue knowledge is never locked — it is only a reminder to check whether it is still accurate.",
  "review.progress": "{index} / {total}",
  "review.due": "Due {date} ({days} ago)",
  "review.keep": "Still accurate · extend {interval}",
  "review.edit": "Needs edits",
  "review.trash": "Retire it",

  "search.title": "Search",
  "search.placeholder": "Search titles, summaries, bodies, notes, sources",
  "search.aria": "Search",
  "search.results.one": "{n} result",
  "search.results.other": "{n} results",
  "search.prompt": "Type a keyword",
  "search.locked": "Adult area is locked: those items are not returned by the query layer at all — not even a count",
  "search.none": "Nothing matched.",
  "search.weights": "Weights: title {title} / summary {summary} / note {note} / source {source} / body {body}",
  "search.hitWeight": "weight {score}",

  "trash.title": "Trash",
  "trash.hint": "Deleted knowledge is kept for 30 days, then removed permanently along with its strings and history.",
  "trash.empty": "The trash is empty.",
  "trash.daysLeft": "clears in {days}",
  "trash.restore": "Restore",
  "trash.emptyAll": "Empty the trash (delete permanently now)",

  "settings.title": "Settings",
  "settings.language": "Language",
  "settings.language.auto": "Follow system",
  "settings.material": "Sheet material",
  "settings.material.night": "Night sheet",
  "settings.material.day": "Day sheet",
  "settings.typeScale": "Type size",
  "settings.scale.small": "Small",
  "settings.scale.normal": "Normal",
  "settings.scale.large": "Large",
  "settings.adult": "Adult area",
  "settings.adult.unlocked": "Unlocked (tap to lock)",
  "settings.adult.locked": "Locked (tap to unlock)",
  "settings.adult.hint": "A plain switch in this build; Face ID unlock needs testing on a real device.",
  "export.title": "Take your data with you",
  "export.hint": "Exports a zip: one Markdown file per item, the complete JSON, and any uncatalogued tray material. Readable without this app.",
  "export.button": "Export everything",
  "export.done": "Exported {n} items (Markdown + JSON)",

  "rail.strings": "{n} strings / limit {cap}",
  "rail.due": "Due {n}",
  "rail.tray": "Uncatalogued tray",
  "rail.tray.count.one": "{n} packet",
  "rail.tray.count.other": "{n} packets",
  "rail.status": "Drawer status",
  "rail.category": "Category",
  "rail.specimens": "Filed",
  "rail.drafts": "Drafts",
  "rail.trash": "Trashed",
  "rail.linkCap": "String limit",
  "rail.specimens.value.one": "{n} sheet",
  "rail.specimens.value.other": "{n} sheets",
  "rail.linkCap.value": "12 per sheet",

  "status.draft": "Draft",
  "status.active": "Filed",
  "status.archived": "Archived",
  "status.trashed": "Trashed",

  "toast.created": "Filed into the cabinet",
  "toast.draft": "Saved as draft — it counts once the label is written",
  "toast.saved": "Saved (history moved forward one version)",
  "toast.trashed": "Moved to trash · restorable for 30 days",
  "toast.restored": "Restored to v{n} (history moved forward)",
  "toast.kept": "Extended one interval",
  "toast.dropped": "Retired · restorable for 30 days",
  "toast.undeleted": "Restored: {title}",
  "toast.emptied.one": "Permanently deleted {n} item (with its strings and history)",
  "toast.emptied.other": "Permanently deleted {n} items (with their strings and history)",
  "toast.linkSoon": "Linking arrives in M3",
  "toast.noChange": "No changes",

  "sync.title": "Sync",
  "sync.hint": "The server only ever stores ciphertext: it holds no passphrase and can read nothing.",
  "sync.serverUrl.required": "Enter the sync server URL first — joining an existing space requires knowing where it lives.",
  "sync.notSetup": "Sync is not set up yet. Once it is, phone and desktop exchange encrypted changes through the server.",
  "sync.serverUrl": "Sync server URL",
  "sync.serverUrl.placeholder": "e.g. http://127.0.0.1:8795 (self-hosted) or https://lifesage.xxx.workers.dev",
  "sync.setup": "Create a passphrase",
  "sync.join": "Join an existing sync space",
  "sync.join.keyId": "Sync space id (shown in the other device's sync settings)",
  "sync.passphrase": "Passphrase (at least 12 characters)",
  "sync.passphrase.confirm": "Type it again",
  "sync.passphrase.mismatch": "The two entries do not match.",
  "sync.passphrase.tooShort": "Passphrase is too short — 12 characters minimum.",
  "sync.passphrase.warn": "The passphrase is never uploaded or stored by us. If you lose it, only the recovery code can save your data.",
  "sync.recovery.title": "This is your recovery code — write it down now",
  "sync.recovery.hint": "If you forget the passphrase, this is the only way back to your data. Print it or put it in a password manager. It is shown once.",
  "sync.recovery.copy": "Copy the code",
  "sync.recovery.copied": "Copied",
  "sync.recovery.confirm": "I have stored it somewhere safe",
  "sync.unlock": "Unlock sync",
  "sync.unlock.recovery": "Use the recovery code instead",
  "sync.lock": "Lock (remove keys from this device)",
  "sync.unlocked": "Unlocked",
  "sync.locked": "Locked",
  "sync.now": "Sync now",
  "sync.syncing": "Syncing…",
  "sync.pending": "{n} to push",
  "sync.lastAt": "Last sync {time}",
  "sync.never": "Never synced",
  "sync.error": "Sync failed: {message}",
  "sync.offline": "Offline: changes are stored locally and will be pushed when you reconnect",
  "sync.keyId": "Sync space",
  "sync.badPassphrase": "Wrong passphrase or recovery code.",
  "sync.conflicts.title": "Conflicts to resolve",
  "sync.conflicts.none": "Nothing to resolve.",
  "sync.conflicts.hint": "The same item was edited on two devices. This copy holds the other side — both texts survive.",
  "sync.conflicts.take": "Take this version",
  "sync.conflicts.discard": "Discard this copy",
  "sync.conflicts.keepBoth": "Keep both",
  "sync.conflicts.toast.take": "Took the copy's content; the original gained a version",
  "sync.conflicts.toast.discard": "Copy moved to trash (restorable for 30 days)",
  "sync.conflicts.toast.keepBoth": "Kept both as separate items",

  "selftest.title": "In-browser self test (IndexedDB)",

  "error.summary.empty": "The summary cannot be empty.",
  "error.summary.tooLong": "Summary is capped at {max} characters; you are at {actual}.",
  "error.note.tooShort": "The collection label is required: write one sentence on why you keep this (at least {min} characters, currently {actual}).",
  "error.category.missing": "Every item needs one top-level category.",
  "warn.summary.tooManySentences": "The summary runs to {count} sentences — split it into two items?",
  "link.error.self": "A sheet cannot be tied to itself.",
  "link.error.duplicate": "These two are already tied.",
  "link.warn.capReached": "This node reached its soft limit of {cap} strings (near end {from}, far end {to}) — write one line of reason to tie another.",

  "category.natural": "Natural sciences",
  "category.life": "Life sciences",
  "category.medicine": "Medicine & health",
  "category.math": "Mathematics",
  "category.engineering": "Engineering",
  "category.cs": "Computing",
  "category.social": "Social sciences",
  "category.history": "History & humanities",
  "category.language": "Language",
  "category.business": "Business & economics",
  "category.law": "Law & institutions",
  "category.art": "Art & design",
  "category.lifeSkills": "Life skills",
  "category.uncategorized": "Uncategorized",
  "category.uncategorized.definition": "Not decided yet. They show up in the re-measure queue to remind you.",
};

export const CATALOGS = { "zh-Hant": zhHant, en } as const;
export type Locale = keyof typeof CATALOGS;
